import React, {useEffect, useState} from "react";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import {basketViewModel} from '../../../viewModels/Basket.viewModel';
import {useHistory} from "react-router-dom";
import messages from "res/messages/farsi";
import {Divider} from "@material-ui/core";
import CircleIconButton from "components/buttons/CircleIconButton";
import StandardButtonFit from "../../../components/buttons/StandardButtonFit";

import ICShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ICTimerIcon from '@material-ui/icons/Timer';
import ICAddIcon from "res/images/add.png";
import ICRemoveIcon from "res/images/remove.png";
import ICInfo from "res/images/info.png";
import ICNotExist from "res/images/not_exist_logo.png";
import ICLogo from "res/images/logo_4.png";
import ICTag from "res/images/tag.png";
import ICTagBlue from "res/images/tag_blue.png";

export default function Product(props) {

    const history = useHistory()
    const product = props.data;

    let initialHour = 0
    let initialMinute = 0
    let initialSecond = 0
    let initialTimerValue = ''

    let getTimerValue = (currentHour, currentMinute, currentSecond) => {
        return validTimeFormat(currentHour) + ":" +
            validTimeFormat(currentMinute) + ":" +
            validTimeFormat(currentSecond)
    }
    let validTimeFormat = (time) => {
        if (time.toString().length <= 1) {
            return "0" + time
        }
        return time
    }
    if (product.time !== undefined && product.time !== '') {
        let timerSplited = product.time.split(":")
        if (timerSplited.length === 3) {
            initialHour = parseInt(timerSplited[0])
            initialMinute = parseInt(timerSplited[1])
            initialSecond = parseInt(timerSplited[2])
            initialTimerValue = getTimerValue(initialHour, initialMinute, initialSecond)
        }
    }

    const [isCancelled, setIsCancelled] = useState(false)
    const [dialogMessageShowStatus, setDialogMessageShowStatus] = useState(false)
    const [defaultSrc, setDefaultSrc] = useState(undefined)
    const [isInBasket, setIsInBasket] = useState(product ? product.basket_added : false)
    const [basketCount, setBasketCount] = useState(product ? product.basket_count : 0)
    const [addProgressIsShow, setAddProgressIsShow] = useState(false)
    const [plusProgressIsShow, setPlusProgressIsShow] = useState(false)
    const [minusProgressIsShow, setMinusProgressIsShow] = useState(false)
    const [timerValue, setTimerValue] = useState(initialTimerValue)
    const [second, setSecond] = useState(initialSecond)
    const [minute, setMinute] = useState(initialMinute)
    const [hour, setHour] = useState(initialHour)

    const timer = () => {
        if (second <= 0 && minute <= 0 && hour <= 0) {
            setTimerValue('')
            return
        }
        let currentSecond = second
        let currentMinute = minute
        let currentHour = hour
        if (currentSecond <= 0) {
            if (currentMinute > 0 || currentHour > 0) {
                currentSecond = 59
                if (currentMinute <= 0) {
                    if (currentHour > 0) {
                        currentMinute = 59
                        currentHour = hour - 1
                    }
                } else {
                    currentMinute = minute - 1
                }
            }
        } else {
            currentSecond = second - 1
        }
        setHour(currentHour)
        setMinute(currentMinute)
        setSecond(currentSecond)
        setTimerValue(getTimerValue(
            currentHour,
            currentMinute,
            currentSecond
        ))
    }

    function getInfoIcon() {
        return <div className="marginRightSmall">
            <CircleIconButton
                hover={"var(--blue_2)"}
                background={"var(--blue_2)"}
                width={"1.1em"} height={"1.1em"}
                icon={<img src={ICInfo} className="xSmallIcon" alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                onClick={() => {
                    setDialogMessageShowStatus(true)
                }}/>
        </div>
    }

    function getBasketButtons() {
        return <div className="fullWidth marginTopSmall" style={{height: "3.5em", position: "absolute", top: "0"}}>
            {(product.limit_count > 0) &&
            <div>
                {isInBasket ?
                    <div className="center horizontalScreen fullWidth">
                        <StandardButtonFit
                            loading={plusProgressIsShow}
                            icon={<img className={'xSmallIcon'} src={ICAddIcon} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                            onClick={() => {
                                if (basketCount >= product.limit_count) {
                                    props.onAlert(messages.productIsLimit, ALERT_TYPES.WARNING)
                                } else {
                                    basketViewModel.plusToBasket(product, () => {

                                    }, () => {

                                    }, () => {
                                        setPlusProgressIsShow(true)
                                    }, () => {
                                        setPlusProgressIsShow(false)
                                    })
                                }
                            }}/>
                        <label style={{width: "40%"}}
                               className="center largeTextBold blueColor_2">
                            {basketCount}
                        </label>
                        <StandardButtonFit
                            loading={minusProgressIsShow}
                            icon={<img className={'xSmallIcon'} src={ICRemoveIcon} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                            onClick={() => {
                                basketViewModel.removeFromBasket(product, () => {

                                }, () => {

                                }, () => {
                                    setMinusProgressIsShow(true)
                                }, () => {
                                    setMinusProgressIsShow(false)
                                })
                            }}/>
                    </div> :
                    <div style={{float: "left", marginLeft: "0.2em"}}>
                        <StandardButtonFit
                            loading={addProgressIsShow}
                            icon={<ICShoppingCartIcon className={'blueColor_2 transformTo_1_2'}/>}
                            onClick={() => {
                                if (basketCount >= product.limit_count) {
                                    props.onAlert(messages.productIsLimit, ALERT_TYPES.WARNING)
                                } else {
                                    basketViewModel.addToBasket(product, () => {

                                    }, () => {

                                    }, () => {
                                        setAddProgressIsShow(true)
                                    }, () => {
                                        setAddProgressIsShow(false)
                                    })
                                }
                            }}/>
                    </div>
                }
            </div>
            }
        </div>
    }

    function getTitleAndImage() {
        return <div>
            <div style={{height: "1.8em"}}/>
            <div>
                <img style={{width: "45%"}}
                     src={defaultSrc !== undefined ? defaultSrc : product.image}
                     onError={() => {
                         setDefaultSrc(ICLogo)
                     }}
                     alt=""
                     className="clickable"
                     onClick={() => {
                         props.onNavigate(history, "/productDetail?v=" + product.product_id)
                     }}/>
            </div>
            <div className="marginLeftRightSmall">
                <div className="horizontalScreen center">
                    <label className="mediumTextBold">
                        {product.name}
                    </label>
                    {(product.description && product.description !== '') &&
                    getInfoIcon()
                    }
                </div>
            </div>
        </div>
    }

    function getPriceSection() {
        return <div
            className="fullWidth clickable"
            style={{position: "absolute", bottom: "0.1em"}}
            onClick={() => {
                props.onNavigate(history, "/productDetail?v=" + product.product_id)
            }}>
            {product.limit_count > 0 &&
            <table className="fullWidth">
                <tbody>
                <tr>
                    <td className="productTagContainer">
                        {product.is_old_price > 0 &&
                        <div style={{position: "relative"}}>
                            <img src={ICTagBlue} className="largeIcon" alt=""/>
                            <label className="whiteColor xSmallTextBold productTag">
                                {messages.oldPrice}
                            </label>
                        </div>
                        }
                    </td>
                    <td className="productPriceContainer mediumTextBold singleLine">
                        <table className="full">
                            <tbody>
                            <tr>
                                <td>
                                    <label className={product.special_price > 0 ?
                                        "textCenterLined grayColor" : "textSimple blueColor_2"}>
                                        {product.price}
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label className="blueColor_2">
                                        {product.special}
                                    </label>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                    <td className="productTagContainer">
                        {product.discount_percent > 0 &&
                        <div style={{position: "relative"}}>
                            <img src={ICTag} className="mediumIcon" alt=""/>
                            <label className="whiteColor smallTextBold productTag">
                                {product.discount_percent}%
                            </label>
                        </div>
                        }
                    </td>
                </tr>
                </tbody>
            </table>
            }
            {(product.time !== undefined && product.time !== "") &&
            <Divider/>
            }
            {(product.time !== undefined && product.time !== "") &&
            getTimer(product, timerValue)
            }
        </div>
    }

    function getTimer() {
        return <table className="blueColor_2 smallTextBold">
            <tbody>
            <tr>
                <td>
                    <ICTimerIcon
                        className="greenColor_2"
                        style={{marginTop: "0.3em"}}
                        fontSize={"small"}/>
                </td>
                <td className="blueColor">
                    {timerValue}
                </td>
                <td className="pinkColor">
                    {messages.remainingTime}
                </td>
            </tr>
            </tbody>
        </table>
    }

    function getNotExistImage() {
        if (product.limit_count <= 0) {
            return <img style={{position: "absolute", top: "0", left: "0"}}
                        className="xxLargeIcon" src={ICNotExist} alt=""/>
        }
    }

    function getDialogMessage() {
        return <DialogMessage
            showStatus={dialogMessageShowStatus}
            title={product.name}
            message={product.description}
            submitTitle={messages.submit}
            onSubmitClicked={() => {
                setDialogMessageShowStatus(false)
            }}
        />
    }

    useEffect(() => {
        basketViewModel.product.subscribe(() => {
            if (isCancelled) return

            let localProducts = basketViewModel.getLocalBasket()
            if (localProducts) {
                if (product) {
                    let index = localProducts.findIndex((element) =>
                        element.product_id === product.product_id
                    )
                    if (index >= 0) {
                        setBasketCount(localProducts[index].basket_count)
                        setIsInBasket(true)
                    } else {
                        setBasketCount(0)
                        setIsInBasket(false)
                    }
                }
            } else {
                setBasketCount(0)
                setIsInBasket(false)
            }
        })
        if (product.time !== undefined && product.time !== '') {
            const id = setInterval(timer, 1000)
            return () => clearInterval(id)
        }

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product, hour, minute, second])

    let opacity = 1
    if (product.isTemp) {
        opacity = 0
    }

    return (<div style={{opacity: opacity}}
                 className="card shadow fullWidth fullHeight">
        {getTitleAndImage()}
        {getBasketButtons()}
        {getPriceSection()}
        {getDialogMessage()}
        {getNotExistImage()}
    </div>)
}